import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, withCtx as _withCtx, createBlock as _createBlock } from "vue"

import { reactive, ref, watchEffect, computed } from 'vue';
  import { ColorVariants } from '@/constants';
  import { request, alert } from '@/utils';
  import { useI18n } from 'vue-i18n';
  import _ from 'lodash';

  interface IForm {
    note1?: string | null;
    note2?: string | null;
  }

  interface IProps {
    note1?: string | null;
    note2?: string | null;
    id: number;
    state: string; // constants.SHIPMENT_STATE_MAP
    collapse: boolean;
  }
  interface IEmits {
    (event: 'change', form: IForm) :void;
  }

  
export default /*#__PURE__*/_defineComponent({
  props: {
    note1: { default: '' },
    note2: { default: '' },
    id: null,
    state: null,
    collapse: { type: Boolean, default: false }
  },
  emits: ["change"],
  setup(__props: any, { emit: emits }: { emit: ({
    (event: 'change', form: IForm) :void;
  }), expose: any, slots: any, attrs: any }) {

const props = __props as { note1: string | null, note2: string | null, id: number, state: string, collapse: boolean }

  const { t, locale } = useI18n();
  const form = reactive<IForm>({
    note1: '',
    note2: ''
  });
  const dialogVisible = ref(false);

  
  

  const canEdit = computed(() => {
    return props.state === 'init' && locale.value === 'ja';
  });

  watchEffect(() => {
    Object.assign(form, _.pick(props, _.keys(form)));
  });

  // const handleNoteFormChange = (data:  any) => {
  //   form[data.key] = data.value;
  // };

  const handleUpdateNote = async () => {
    await request.put(`/program_shipments/${props.id}`, form);
    dialogVisible.value = false;
    emits('change', form);
    alert({ title: t('Success'), content: t('Operation success'), });
  };


return (_ctx: any,_cache: any) => {
  const _component_AppDialog = _resolveComponent("AppDialog")!
  const _component_AppLoadingButton = _resolveComponent("AppLoadingButton")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_AppDialog, {
      visible: dialogVisible.value,
      "onUpdate:visible": _cache[0] || (_cache[0] = ($event: any) => ((dialogVisible).value = $event)),
      class: "dialog-note",
      title: _unref(t)('remark'),
      btns: _unref(canEdit) ? [
      {
        text: _unref(t)('Submit'),
        style: _unref(ColorVariants).primary,
        click: handleUpdateNote
      }
    ] : []
    }, null, 8, ["visible", "title", "btns"]),
    (!__props.collapse)
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
          _createTextVNode(_toDisplayString([__props.note1, __props.note2].filter(Boolean).join(' ')), 1)
        ], 64))
      : _createCommentVNode("", true),
    (__props.collapse || _unref(canEdit))
      ? (_openBlock(), _createBlock(_component_AppLoadingButton, {
          key: 1,
          size: "sm",
          variant: _unref(ColorVariants).primary,
          onClick: _cache[1] || (_cache[1] = _withModifiers(($event: any) => (dialogVisible.value = true), ["stop"]))
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_unref(t)('update_remark')), 1)
          ]),
          _: 1
        }, 8, ["variant"]))
      : _createCommentVNode("", true)
  ], 64))
}
}

})